// extracted by mini-css-extract-plugin
export default {"card":"styles_card__GFED6","animating":"styles_animating__sLY3y","waves":"styles_waves__tCgOR"};